// extracted by mini-css-extract-plugin
export var notificationHost = "_ea-0";